(function() {
  angular.module('forgotPassword')
  .controller('forgotPasswordController', ['$scope','$log','$state','loginUserService','User','$translate','$stateParams',
  function($scope, $log, $state,loginUserService,User,$translate,$stateParams) {
    var vm = this;
    vm.reset = reset;
    vm.submit = submit;
    vm.formErrors = ['unverifiedEmail','UserNotFound'];
    if (loginUserService.loginModel().userIdentified) {
      loginUserService.init();
      $state.go('root');
    }
    vm.model = _.pick(loginUserService.loginModel(),['userId','email','challengeResponses']);
    vm.model.userId=$stateParams.userId;

    function clearFormErrors(){
      _.each(vm.formErrors, (formError) => {
        $scope.passwordResetForm.$setValidity(formError,true);
      });
    }

    function saveModel(){
      loginUserService.loginModel(vm.model);
    }

    function reset(){
      vm.model=loginUserService.loginModel({});
      $scope.errorControl.hideErrors();
    }

    function submit(){
      clearFormErrors();
      $scope.errorControl.showErrors();
      if ($scope.passwordResetForm.$valid) {
          vm.running = true;
          User.challengeResponses(vm.model,(result) => {
            vm.running = false;
            if (result.emailVerified && result.challenges){
              showChallenges(result.challenges);
            }else{
              $scope.passwordResetForm.$setValidity('unverifiedEmail', result.emailVerified);
              $scope.passwordResetForm.$setValidity('UserNotFound', result.emailVerified!==undefined);
            }
          },(error) => {
            vm.running = false;
            saveModel();
          });
      }
    }

    function showChallenges(challenges){
      _.each(challenges, (challenge,index) => {
          vm.model.challengeResponses[index].challenge = challenge;
          vm.model.challengeResponses[index].response = undefined;
      });
      saveModel();
      $state.go('challenges');
    }

  }]);
})();
